import React, { useEffect, useState } from 'react';
import ContractRenewalManagement from './contractrenewal/ContractRenewalManagement';

function normalizeCompanyCodes(companyCodes) {
  return Array.isArray(companyCodes)
    ? companyCodes.map((code) => String(code || '').toUpperCase()).filter(Boolean)
    : [];
}

export default function IntegratedContractRenewal({ menuId, companyCodes, pageTitle }) {
  const normalizedCodes = normalizeCompanyCodes(companyCodes);
  const [selected, setSelected] = useState(() => [...normalizedCodes]);

  useEffect(() => {
    setSelected((prev) => {
      const stillValid = prev.filter((code) => normalizedCodes.includes(code));
      return stillValid.length > 0 ? stillValid : [...normalizedCodes];
    });
  }, [companyCodes]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ContractRenewalManagement
      integratedMenuId={menuId}
      companyCodes={normalizedCodes}
      selectedCompanyCodes={selected}
      setSelectedCompanyCodes={setSelected}
      pageTitle={pageTitle || '계약갱신관리'}
    />
  );
}
